import { setCookie } from 'OK/cookie';

let detectPromise: Promise<boolean> | null = null;

export const detectDzenBlock = (): Promise<Boolean> => {
    if (detectPromise) {
        return detectPromise;
    }

    detectPromise = fetch('//dzen.ru/partner/ok')
        .then(() => false)
        .catch(() => true);

    return detectPromise;
}

export const activate = () => {
    detectDzenBlock().then((detected) => {
        setCookie('__dzbd', String(detected), 15, '/');
    });
}

export default {
    activate,
};
